<template>
    <div >
        <step4-modal v-if="showmodal" :block="this.get_block" :modal="this.get_modal" :paymentStatus="this.get_payment_status" :total="this.get_total" :cb_online="this.cb_online" :order="fullorder" :errors="paymentMethodErrors"
                      @send="realize_payment($event)" @cancel="showmodal = false" @close="debouncedHandleSucess">
        </step4-modal>
        <order :order="fullorder"></order>
        <div v-if="fullorder.payment_status == 'pending' && this.get_all_payments_methods">
          <h5>Paiement</h5>
          <table class="table table-condensed search-table">
            <thead>
                <th class="v-align-middle">
                  Moyen de paiement
                </th>
                <th class="v-align-middle">
                  Description
                </th>
            </thead>
            <tbody>
              <template v-for="(payment_method, idx) in payment_methods">
                <tr>
                  <td class="v-align-middle">
                    {{payment_method.block.title}}
                  </td>
                  <td class="v-align-middle">
                    {{payment_method.block.subtitle}}
                  </td>
                  <td class="v-align-middle">
                    <button class="btn btn-default btn-sm m-t-10" @click="setModal(idx, $event)">
                      Selectionner
                    </button>
                  </td>
                </tr>
              </template>
              <tr>
                <td  class="v-align-middle">
                  Paiement en ligne
                </td>
                <td class="v-align-middle">
                  Paiement via Worldline (CB, Paypal, Apple Pay et Google Pay)
                </td>
                <td class="v-align-middle">
                  <button class="btn btn-default btn-sm m-t-10" @click="setModal(-1, $event)">
                    Sélectionner
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else-if="fullorder.stored_in_erp && fullorder.can_be_captured">
          <h5>Cette commande a été marquée comme payée par carte bancaire en ligne, afin de finaliser la procédure veuillez utiliser le bouton suivant : </h5>
          <button class="btn btn-sucess" @click="handleCapture()">
            <span>Capturer les autorisations</span>
          </button>
        </div>
    </div>
</template>
<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import Step4Modal from './Step4Modal'
import Order from "./Details/ValidationRequestable/Order"
import cookies from "cookiesjs"

export default {
    name:"Step4",

    components:{
      Step4Modal,
      Order,
    },

    data() {
      return {
        showmodal:false,
        block:{},
        modal:{},
        errors:[],
        cb_online:false,
        debouncedHandleSucess:null,
        ready:false,
      }
    },

    methods:{
      ...mapActions('demands', ['getPaymentMethods','make_payment','get_options','captureAutorizations','resetDemandsOrders']),

      handleSuccess(event) {
        this.block = {}
        this.modal = {}
        this.showmodal = false
        this.cb_online = false
        this.resetDemandsOrders()
            .then(() => this.get_options({order_id:event}))
      },

      setModal(idx, event){
        if (event && this.showmodal == false)
        {
          if (idx == -1)
          {
            this.redirectToHostedCheckout()
          }
          else 
          {
            this.block = this.payment_methods[idx].block
            this.modal = this.payment_methods[idx].modal
            this.errors = []
            this.showmodal = true
            this.cb_online = false
          }
        }
        else if (event && this.showmodal == true) {
          this.block = {}
          this.modal = {}
          this.showmodal = false
          this.cb_online = false
        }
      },

      redirectToHostedCheckout() {
        const params = {
          token: cookies('token'),
          origin_url: 'AGENCY_SPACE_URL',
          route_name: this.$route.name,
          route_id: this.$route.params.id,
          tab: 'step4',
          locale: navigator.language,
          timezoneOffsetUtcMinutes: (new Date).getTimezoneOffset(),
          browserColorDepth: screen.colorDepth,
          browserScreenHeight: screen.height,
          browserScreenWidth: screen.width
        }

        const urlParamsForPHP = $.param(params)

        window.location = `${__API_URL__}/orders/${this.order_id}/hosted_checkout_page?${urlParamsForPHP}`
      },

      realize_payment(event) {
        if (event)
        {
          let payload = {
            order_id: this.order_id, 
            other: event
          }

          this.errors = []
          // The order is refreshed either way, hiding the payment table once it is paid: a refusal may
          // come from an online payment found meanwhile, its message staying in the modal
          this.make_payment(payload)
              .then(
                () => this.handleSuccess(this.order_id),
                (error) => {
                  this.errors.push(error)
                  this.get_options({order_id: this.order_id})
                }
              )
        }
        else
          console.error('Missing params to store payment')
      },

      handleCapture() {
        this.captureAutorizations(this.fullorder.id)
            .then(() =>
              this.resetDemandsOrders()
              .then(() => this.get_options({order_id:this.fullorder.id}))
            )
      },

    },

    computed:{
      ...mapState('demands', ['payment_methods',"orders","forms"]),
      ...mapGetters('demands', ['get_payment_methods']),

      order_id () {
        var tf = _.find(this.forms, (form) => form.main_request.request.id == this.$route.params.id)
        if (tf && tf.main_request && tf.main_request.model_new_version && tf.main_request.model_new_version.order)
          return tf.main_request.model_new_version.order.id
        return false
      },

      order () {
        var tf = _.find(this.forms, (form) => form.main_request.request.id == this.$route.params.id)
        if (tf && tf.main_request && tf.main_request.model_new_version && tf.main_request.model_new_version.order)
          return tf.main_request.model_new_version.order
        return false
      },

      get_all_payments_methods(){
        var tmp = this.order_id
        if (this.order_id != null && this.order_id != undefined && this.order_id != false)
          {
            this.getPaymentMethods({order_id:this.order_id})
            return true
          }
        return false
      },

      get_block(){
        return this.block
      },

      get_modal() {
        return this.modal
      },

      get_payment_status(){
        if (this.order)
          return this.order.payment_status
      },

      // The refusal of the payment method (e.g. an online payment found meanwhile)
      paymentMethodErrors() {
        return _.flatMap(this.errors, (error) => _.get(error, 'response.data.errors.payment_method', []))
      },

      get_total(){
        if (this.order)
          return this.order.total_to_pay
      },

      fullorder(){
        var tmp = _.find(this.orders, (order) => order.id == this.order.id)
        if (tmp)
          return tmp
        else {
          return false
        }
      },

    },

    mounted(){
      this.get_all_payments_methods
    },

    watch : {
      order : function () {
        this.get_options({order_id:this.order.id})
      }
    },

    created(){
      this.get_all_payments_methods
      this.debouncedHandleSucess = _.debounce(this.handleSuccess, 3000)

    }
}

</script>
<style>
</style>



// WEBPACK FOOTER //
// client/components/Demands/Step4.vue